<header>
    <h2>
        {{ label }}
    </h2>
    <button mat-icon-button
            [matTooltip]="'shared.treeSelection.refresh.summary' | translate"
            (click)="onRefreshSelection()">
        <mat-icon>refresh</mat-icon>
    </button>
</header>

<div class="filter">
    <mat-form-field>
        <mat-label>{{ 'shared.filter.shortLabel' | translate }}</mat-label>
        <input matInput
               type="text"
               [formControl]="filterControl">
    </mat-form-field>
</div>
<section class="tree">
    <app-selection-category [categories]="tree"
                            [depsLabel]="depsLabel"
                            [isRoot]="true"
                            [selection]="selection"
                            (categorySelected)="onCategorySelected($event)"
                            (itemSelected)="onItemSelected($event)"></app-selection-category>
</section>